import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Hazard';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.25 9.75C10.8925 9.75 10.5847 10.0023 10.5146 10.3529L9.76456 14.1029C9.7205 14.3232 9.77754 14.5517 9.91999 14.7255C10.0624 14.8993 10.2753 15 10.5 15H11.8351L11.2646 17.8529C11.193 18.2107 11.3893 18.568 11.7296 18.6995C12.0698 18.8311 12.4554 18.6987 12.6431 18.3859L14.8931 14.6359C15.0321 14.4042 15.0358 14.1156 14.9026 13.8805C14.7695 13.6453 14.5202 13.5 14.25 13.5H12.9149L13.4854 10.6471C13.5295 10.4268 13.4725 10.1983 13.33 10.0245C13.1876 9.85074 12.9747 9.75 12.75 9.75H11.25Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6708 3.41459C12.5438 3.1605 12.2841 3 12 3C11.7159 3 11.4562 3.1605 11.3292 3.41459L3.07918 19.9146C2.96293 20.1471 2.97536 20.4232 3.11201 20.6443C3.24867 20.8654 3.49007 21 3.75 21H20.25C20.5099 21 20.7513 20.8654 20.888 20.6443C21.0246 20.4232 21.0371 20.1471 20.9208 19.9146L12.6708 3.41459ZM12 5.42705L19.0365 19.5H4.96353L12 5.42705Z" fill="currentColor"/>
  </svg>
`;

const HazardIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      d='M11.25 9.75C10.8925 9.75 10.5847 10.0023 10.5146 10.3529L9.76456 14.1029C9.7205 14.3232 9.77754 14.5517 9.91999 14.7255C10.0624 14.8993 10.2753 15 10.5 15H11.8351L11.2646 17.8529C11.193 18.2107 11.3893 18.568 11.7296 18.6995C12.0698 18.8311 12.4554 18.6987 12.6431 18.3859L14.8931 14.6359C15.0321 14.4042 15.0358 14.1156 14.9026 13.8805C14.7695 13.6453 14.5202 13.5 14.25 13.5H12.9149L13.4854 10.6471C13.5295 10.4268 13.4725 10.1983 13.33 10.0245C13.1876 9.85074 12.9747 9.75 12.75 9.75H11.25Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.6708 3.41459C12.5438 3.1605 12.2841 3 12 3C11.7159 3 11.4562 3.1605 11.3292 3.41459L3.07918 19.9146C2.96293 20.1471 2.97536 20.4232 3.11201 20.6443C3.24867 20.8654 3.49007 21 3.75 21H20.25C20.5099 21 20.7513 20.8654 20.888 20.6443C21.0246 20.4232 21.0371 20.1471 20.9208 19.9146L12.6708 3.41459ZM12 5.42705L19.0365 19.5H4.96353L12 5.42705Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: HazardIcon,
  IconSvg: IconSvg
} as IconType;
